import React from 'react';
const ExportAddOnsCanvas = ({ addOnItem, exportAddOnsCanvasRef }) => {
    var _a;
    return (React.createElement("div", { className: "fg-cust__export-canvas fg-cust__export-canvas--add-on", ref: exportAddOnsCanvasRef },
        React.createElement("div", { className: `fg-cust__dynamic-image ${addOnItem.handle}` }, (_a = addOnItem.products) === null || _a === void 0 ? void 0 : _a.map((innerProduct, innerIndex) => {
            if (innerProduct.part == 'parent-product')
                return null;
            return innerProduct.otherVariants.map((addOnVariant, index) => {
                return (React.createElement("div", { key: `add-on-part--${innerIndex}--${index}`, className: `fg-cust__dynamic-image--elem fg-cust__dynamic-image--${innerProduct.part} ${innerProduct.selectedVariant.id == addOnVariant.id ? 'selected' : ''}` },
                    React.createElement("div", { className: "fg-cust__dynamic-image--product--inner" },
                        React.createElement("img", { key: index, src: addOnVariant.customiser_image, alt: `${innerProduct.title} in ${addOnVariant.title}`, className: `${innerProduct.selectedVariant.id == addOnVariant.id ? 'selected' : ''}` }))));
            });
        }))));
};
export default ExportAddOnsCanvas;
